import {
  getWorkspaceAgentPanelFloatMaxLeft,
  getWorkspaceAgentPanelFloatMaxWidth,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentPanelFloatHorizontalBounds';
import { WORKSPACE_AGENT_PANEL_SNAP_THRESHOLD_PX } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';
import { type WorkspaceAgentInFlowDock } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';

export type WorkspaceAgentPanelDropDock = WorkspaceAgentInFlowDock | 'float';

export type GetWorkspaceAgentPanelDropDockParams = {
  left: number;
  viewportWidth: number;
  width: number;
};

/** True when the card can sit at the left padding with its trailing edge outside the snap zone. */
export const canWorkspaceAgentPanelFloatWidthClearRightSnapZone = (viewportWidth: number, width: number): boolean =>
  width <= getWorkspaceAgentPanelFloatMaxWidth(viewportWidth);

/** Max-width floats hit the right padding clamp outside the snap zone — not a drag-to-dock. */
export const isWorkspaceAgentPanelFloatRestingAtRightClamp = (
  viewportWidth: number,
  left: number,
  width: number,
): boolean =>
  width >= getWorkspaceAgentPanelFloatMaxWidth(viewportWidth) &&
  left >= getWorkspaceAgentPanelFloatMaxLeft(viewportWidth, width);

export const getWorkspaceAgentPanelDropDock = ({
  left,
  viewportWidth,
  width,
}: GetWorkspaceAgentPanelDropDockParams): WorkspaceAgentPanelDropDock => {
  const distanceToRight = viewportWidth - (left + width);

  if (distanceToRight > WORKSPACE_AGENT_PANEL_SNAP_THRESHOLD_PX) {
    return 'float';
  }

  if (!canWorkspaceAgentPanelFloatWidthClearRightSnapZone(viewportWidth, width)) {
    return 'float';
  }

  if (isWorkspaceAgentPanelFloatRestingAtRightClamp(viewportWidth, left, width)) {
    return 'float';
  }

  return 'right';
};
